import { IComponentOptions, IController } from "angular";

// Search is still in progress
export class WizardSearchSelectAllCtrl implements IController {
  searchTerm: string;
  searchPlaceholder: string;
  selectAllChecked: boolean;
  index: number;
  hideSelectAll: boolean;

  private onSelectAllUpdate;
  private onSearchTermUpdate;

  constructor() {
    this.searchTerm = "";
  }

  updateSelectAllValue(): void {
    this.onSelectAllUpdate({ changes: this.selectAllChecked });
  }

  updateSearchTermValue(): void {
    this.onSearchTermUpdate({ changes: this.searchTerm });
  }
}

export const WizardSearchSelectAllComponent: IComponentOptions = {
  bindings: {
    onSearchTermUpdate: "&",
    onSelectAllUpdate: "&",
    searchPlaceholder: "<",
    searchTerm: "<",
    index: "<",
    hideSelectAll: "<",
    selectAllChecked: "=",
  },
  controller: WizardSearchSelectAllCtrl,
  templateUrl: require("./search-select-all.jade"),
  controllerAs: "$ctrl",
};
